import { BarChart } from "@mui/x-charts";
import { CustomItemTooltipBD } from "../../helpers/components/CustomTooltipBD";
import { useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { handleBarClickPopupforBars } from "../../helpers/funcs/handleBarClickPopupforBars";
import TrendsBreakdownPopupForBars from "../TrendsBreakdownPopup/TrendsBreakdownPopupForBars";
import { TrendsBreakdownQueryIds } from "../../helpers/funcs/trendsAllQueryIDs";

const TrendsBDAdsAdgroup = ({ sortedDataAdGroup, seriesAdGroup }: any) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const valueSuffix = searchParams.get("value_suffix") || "";
  const [popupOpen, setPopupOpen] = useState(false);
  const [selectedBarDataAdsAdgroup, setSelectedBarDataAdsAdgroup] =
    useState<any>(null);

  const onBarClick = (_: any, params: any) => {
    handleBarClickPopupforBars({
      params,
      series: seriesAdGroup,
      setSelectedBarData: setSelectedBarDataAdsAdgroup,
      setPopupOpen,
      searchParams,
      section: "Ads (Ad Group)",
      queryID: TrendsBreakdownQueryIds.AD_GROUP,
      setSearchParams,
    });
  };

  // Handle popup close
  const handleClosePopup = () => {
    setPopupOpen(false);
    setSelectedBarDataAdsAdgroup(null);
    const updatedParams = new URLSearchParams(searchParams);
    updatedParams.delete("section");
    updatedParams.delete("queryID");
    setSearchParams(updatedParams);
  };

  useEffect(() => {
    const section = searchParams.get("section");
    const queryID = searchParams.get("queryID");

    if (section || queryID) {
      const updatedParams = new URLSearchParams(searchParams);
      updatedParams.delete("section");
      updatedParams.delete("queryID");
      setSearchParams(updatedParams, { replace: true }); // avoid history entry
    }
    // eslint-disable-next-line
  }, []);
  return (
    <>
      <BarChart
        data-tracker="490"
        dataset={sortedDataAdGroup}
        series={seriesAdGroup}
        xAxis={[
          {
            scaleType: "band",
            dataKey: "x",
            disableLine: true,
          },
        ]}
        yAxis={[
          {
            dataKey: "y",
            disableLine: true,
            disableTicks: true,
          },
        ]}
        leftAxis={null}
        rightAxis={{}}
        height={380}
        margin={{ left: 30, right: 56, top: 25, bottom: 160 }}
        grid={{ vertical: false, horizontal: true }}
        onItemClick={onBarClick}
        slotProps={{
          legend: {
            direction: "row",
            position: {
              vertical: "bottom",
              horizontal: "left",
            },
            labelStyle: {
              fontSize: 12,
            },
            itemMarkWidth: 12,
            itemMarkHeight: 2,
            markGap: 8,
            itemGap: 10,
            padding: 28,
          },
        }}
        sx={{
          [`& .MuiChartsAxis-tickLabel`]: {
            fill: "grey !important",
          },
          [`& .MuiChartsAxis-tick`]: {
            stroke: "grey !important",
          },
          [`& .MuiChartsLegend-root text`]: {
            fill: "grey !important",
          },
        }}
      >
        <CustomItemTooltipBD
          dataset={sortedDataAdGroup}
          valueSuffix={valueSuffix}
        />
      </BarChart>
      <TrendsBreakdownPopupForBars
        open={popupOpen}
        onClose={handleClosePopup}
        data={selectedBarDataAdsAdgroup}
      />
    </>
  );
};

export default TrendsBDAdsAdgroup;
